import {
    Component
} from '@angular/core';
import {
    ChangeDetectorRef
} from '@angular/core';
import {
    ApperyioHelperService
} from '../../scripts/apperyio/apperyio_helper';
import {
    ApperyioMappingHelperService
} from '../../scripts/apperyio/apperyio_mapping_helper';
import {
    ExportedClass as NeurService
} from '../../scripts/custom/NeurService';
import {
    HEART_COLORS
} from '../../../app/scripts/custom/NeurConstants';
import {
    IMAGE_RATIO
} from '../../../app/scripts/custom/NeurConstants';
import {
    $aio_empty_object
} from '../../scripts/interfaces';
import {
    Input
} from '@angular/core';
import {
    Output
} from '@angular/core';
import {
    EventEmitter
} from '@angular/core';
import {
    ViewChild
} from '@angular/core';
@Component({
    templateUrl: 'PlaceCard.html',
    selector: 'component-place-card',
    styleUrls: ['PlaceCard.css', 'PlaceCard.scss']
})
export class PlaceCard {
    public heart_colors: any;
    public screenOrientation: any;
    public widthForVW: number;
    public heightForVW: number;
    public $a: ApperyioHelperService;
    public $v: {
        [name: string]: any
    };
    public aioChangeDetector: ChangeDetectorRef;
    public currentItem: any = null;
    public mappingData: any = {};
    public __getMapping(_currentItem, property, defaultValue, isVariable?, isSelected?) {
        return this.$aio_mappingHelper.getMapping(this.mappingData, _currentItem, property, defaultValue, isVariable, isSelected);
    }
    public __isPropertyInMapping(_currentItem, property) {
        return this.$aio_mappingHelper.isPropertyInMapping(this.mappingData, _currentItem, property);
    }
    public __setMapping(data: any = {}, keyName: string, propName?: string): void {
        const changes = data.detail || {};
        if (propName) {
            this.mappingData = this.$aio_mappingHelper.updateData(this.mappingData, [keyName], changes[propName]);
        } else {
            this.mappingData = this.$aio_mappingHelper.updateData(this.mappingData, [keyName], changes.value);
        }
        this.$aio_changeDetector.detectChanges();
    }
    public __bindedMethods: any = {};
    @Input() public landscape_width: any;
    @Input() public place: any;
    ngOnInit(): any {
        this.screenOrientation = this.neurService.screen_orientation;
        this.set_image_size();
        let self = this;
        this.neurService.getScreenOrientation().subscribe((orientation) => {
            self.screenOrientation = self.neurService.screen_orientation;
            self.set_image_size();
        });
    }
    set_image_size(): any {
        if (!this.screenOrientation || this.screenOrientation.startsWith('portrait')) {
            this.widthForVW = 100;
            this.heightForVW = (this.widthForVW / IMAGE_RATIO.WIDTH * IMAGE_RATIO.HEIGHT);
        } else {
            this.landscape_width? this.widthForVW = this.landscape_width: 61.8;
            this.heightForVW = (this.widthForVW / IMAGE_RATIO.WIDTH * IMAGE_RATIO.HEIGHT);
        }
    }
    constructor(public Apperyio: ApperyioHelperService, private $aio_mappingHelper: ApperyioMappingHelperService, private $aio_changeDetector: ChangeDetectorRef, public neurService: NeurService) {
        this.$a = this.Apperyio;
        this.$v = this.Apperyio.vars;
        this.heart_colors = HEART_COLORS;
        this.widthForVW = 100;
        this.heightForVW = 56.25;
        this.aioChangeDetector = this.$aio_changeDetector;
    }
}